import { QueryRequestProvider } from "../../merchant-management/core/QueryRequestProvider";
import { QueryResponseProvider } from "../../merchant-management/core/QueryResponseProvider";
import CreateUser from "./CreateUser";

const CreateUserWrapper = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <CreateUser />
      </QueryResponseProvider>
    </QueryRequestProvider>
  );
};

export default CreateUserWrapper;
